import { Component, effect, inject, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from './core/auth.service';
import { CompanyService } from './core/company.service';
import { HealthService } from './core/health.service';

@Component({
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  selector: 'app-root',
  styleUrl: './app.scss',
  templateUrl: './app.html',
})
export class App {
  protected readonly env = environment.name;
  protected readonly auth = inject(AuthService);
  protected readonly companies = inject(CompanyService);
  private readonly router = inject(Router);
  protected readonly apiOk = signal<boolean | null>(null);

  constructor() {
    inject(HealthService).get().subscribe({
      next: (h) => this.apiOk.set(h.status === 'ok'),
      error: () => this.apiOk.set(false),
    });
    // Logou: carrega as empresas do menu.
    effect(() => {
      if (this.auth.user() && !this.companies.list().length) this.companies.refreshList();
    });
  }

  protected async logout(): Promise<void> {
    await this.auth.logout();
    this.companies.list.set([]);
    await this.router.navigateByUrl('/login');
  }
}
